import { API_BASE_URL } from '../config/env';

export interface AuthLoginResult {
  accessToken: string;
  refreshToken: string;
  user: {
    id: string;
    email?: string;
    nome?: string;
    saldo?: number;
    avatar?: {
      profileUrl?: string;
      seatUrl?: string;
    } | null;
    avatarUrl?: string;
  };
}

export async function loginWithCpf(cpf: string, senha: string): Promise<AuthLoginResult> {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ cpf, senha }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const retryAfter = Number(payload.retryAfter);
    const baseMessage = payload.erro || payload.error || 'Nao foi possivel entrar no portal financeiro.';
    const message =
      response.status === 429 && Number.isFinite(retryAfter) && retryAfter > 0
        ? `${baseMessage} Tente novamente em ${retryAfter}s.`
        : baseMessage;
    const error = new Error(message);
    (error as any).status = response.status;
    (error as any).retryAfter = Number.isFinite(retryAfter) ? retryAfter : undefined;
    throw error;
  }

  return payload as AuthLoginResult;
}
